import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const frsSection = document.querySelectorAll('.featured-resources-section');

    frsSection.forEach(section => {
        const frsCardSlider = section.querySelector('.frs-card-slider');

        new Swiper(frsCardSlider, {
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                prevEl: section.querySelector('.frs-button-prev'),
                nextEl: section.querySelector('.frs-button-next'),
            },
            pagination: {
                el: section.querySelector('.frs-pagination'),
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    });
});